import { PortalDialogProps } from "@app/services/modal.service";
import Modal from "../modal/modal.component";
import { Form, Formik } from "formik";
import { FormControl } from "../form-control";
import Input from "../input";
import Button from "../button";
import * as Yup from "yup";

interface ConfirmModalProps {
  confirm: string;
}

const validationSchema = Yup.object().shape({
  confirm: Yup.string()
    .required("Bạn phải nhập 'confirm'")
    .oneOf(["confirm"], "Bạn phải nhập chính xác 'confirm'"),
});

const RevokeVipModal = ({
  portalDialogRef,
}: PortalDialogProps<ConfirmModalProps>) => {
  const onSubmit = (values: { confirm: string }) => {
    portalDialogRef.close({ confirm: values });
  };

  return (
    <Modal onCancel={portalDialogRef.close}>
      <div className="w-[423px] py-7 px-6">
        <div className="text-black font-semibold text-xl">Thu hồi VIP</div>
        <Formik
          initialValues={{ confirm: "" }}
          validationSchema={validationSchema}
          onSubmit={onSubmit}
          validateOnChange
          validateOnBlur
        >
          {({ handleSubmit }) => (
            <Form onSubmit={handleSubmit}>
              <div className="text-sm mt-4 text-gray-500">
                Nhập “confirm” để thu hồi VIP của người này
              </div>
              <FormControl name="confirm">
                <Input className="mt-3" placeholder="Confirm" />
              </FormControl>

              <div className="mt-8 flex justify-center gap-4">
                <Button
                  size="xs"
                  label="Hủy"
                  theme="secondary"
                  width={180}
                  className="!h-[51px] !leading-[51px]"
                  labelClassName="text-xl"
                  onClick={portalDialogRef.close}
                />
                <Button
                  type="submit"
                  size="xs"
                  label="Thu hồi"
                  width={180}
                  className="!h-[51px] !leading-[51px]"
                  labelClassName="text-xl"
                />
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </Modal>
  );
};

export default RevokeVipModal;
